import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ModalVideo from "react-modal-video";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import HouseDetailPageInfo from "../data/HouseDetailPageInfo";
import { useParams, useLocation } from "react-router-dom";
import Slider from "react-slick";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// 🔹 Slider settings
const portfolioSlick2 = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnHover: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3000,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3000,
      },
    },
  ],
};

function fetchExistingImages(
  slug,
  type,
  maxImages = 36,
  initialLoad = 6,
  imageCount = null,
) {
  return new Promise((resolve) => {
    const cacheKey = `gallery-cache-${slug}`;
    const cached = localStorage.getItem(cacheKey);

    if (imageCount && imageCount < maxImages) {
      maxImages = imageCount;
      initialLoad = imageCount;
    }

    if (cached) {
      const parsed = JSON.parse(cached);
      if (Array.isArray(parsed) && parsed.length > 0) {
        resolve(parsed.slice(0, initialLoad));

        setTimeout(() => {
          loadRemainingImages(
            slug,
            type,
            parsed.length + 1,
            maxImages,
            parsed,
            imageCount,
          );
        }, 1000);

        return;
      }
    }

    const base =
      type === "land"
        ? `/assets/images/land/${slug}`
        : `/assets/images/house/${slug}`;

    const extensions = ["jpg"];
    const validImages = [];

    const tryNext = (i) => {
      if (i > maxImages) {
        if (validImages.length > 0) {
          localStorage.setItem(cacheKey, JSON.stringify(validImages));
        }

        resolve(validImages.slice(0, initialLoad));

        setTimeout(() => {
          loadRemainingImages(
            slug,
            type,
            validImages.length + 1,
            maxImages,
            validImages,
            imageCount,
          );
        }, 1000);

        return;
      }

      const url = `${base}/${i}.jpg`;
      const img = new Image();
      img.src = url;

      img.onload = () => {
        validImages.push(url);
        tryNext(i + 1);
      };

      img.onerror = () => {
        tryNext(i + 1);
      };
    };

    tryNext(1);
  });
}

function loadRemainingImages(
  slug,
  type,
  startIndex,
  maxImages,
  existingImages,
  imageCount = null,
) {
  const cacheKey = `gallery-cache-${slug}`;

  if (imageCount && imageCount < maxImages) {
    maxImages = imageCount;
  }

  const base =
    type === "land"
      ? `/assets/images/land/${slug}`
      : `/assets/images/house/${slug}`;

  const extensions = ["jpg"];
  const validImages = [...existingImages];

  const tryNext = (i) => {
    if (i > maxImages) {
      if (validImages.length > existingImages.length) {
        localStorage.setItem(cacheKey, JSON.stringify(validImages));
      }
      return;
    }

    const url = `${base}/${i}.jpg`;
    const img = new Image();
    img.src = url;

    img.onload = () => {
      validImages.push(url);
      tryNext(i + 1);
    };

    img.onerror = () => {
      tryNext(i + 1);
    };
  };

  tryNext(startIndex);
}

class BlogDetailsContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      isLightboxOpen: false,
      photoIndex: 0,
      gallery: [],
      isLoading: true,
    };
    this.openModal = this.openModal.bind(this);
  }

  openModal() {
    this.setState({ isOpen: true });
  }

  async componentDidMount() {
    const { blog } = this.props;

    const images = await fetchExistingImages(
      blog.slug,
      blog.type,
      60,
      3,
      blog.imageCount || 59,
    );

    this.setState({ gallery: images, isLoading: false });
  }

  openLightbox = (index) => {
    this.setState({ isLightboxOpen: true, photoIndex: index });
  };

  render() {
    const { blog } = this.props;
    const { isLightboxOpen, photoIndex, gallery, isLoading } = this.state;

    if (!blog) return <p>Blog not found!</p>;

    return (
      <>
        <PageHelmet pageTitle={blog.title} />
        <Header
          headertransparent="header--transparent"
          colorblack="color--black"
          logoname="logo.png"
        />

        {/* BACKGROUND */}
        <div
          className="rn-page-title-area pt--120 pb--190 position-relative"
          style={{
            backgroundImage: `url(${
              blog.mainImage ||
              gallery[0] ||
              blog.PortfolioList2?.[0]?.image ||
              blog.content.find((c) => c.type === "image")?.src ||
              "/images/default-bg.jpg"
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.55)",
              zIndex: 1,
            }}
          />
          <div
            className="container"
            style={{ position: "relative", zIndex: 2 }}
          >
            <div className="row">
              <div className="col-lg-12">
                <div className="blog-single-page-title text-center pt--100">
                  <h2
                    className="title theme-gradient"
                    style={{ color: "#fff" }}
                  >
                    {blog.title}
                  </h2>
                  <p style={{ color: "#eaeaea" }}>{blog.description}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SLIDER */}
        <div className="portfolio-area pt--120 bg_color--1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title text-center service-style--3 mb--30">
                  <h2 className="title">{blog.detailTitle}</h2>
                  <p>{blog.detailDescription}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="wrapper portfolio-sacousel-inner mb--55">
            <div className="portfolio-slick-activation mt--70 mt_sm--40">
              <Slider {...portfolioSlick2}>
                {isLoading
                  ? Array(3)
                      .fill()
                      .map((_, i) => (
                        <div className="portfolio" key={i}>
                          <Skeleton
                            height={300}
                            borderRadius={12}
                            baseColor="#e0e0e0"
                            highlightColor="#f5f5f5"
                          />
                        </div>
                      ))
                  : gallery.map((img, index) => (
                      <div className="portfolio" key={index}>
                        <div
                          className="thumbnail-inner"
                          style={{ cursor: "zoom-in" }}
                          onClick={() => this.openLightbox(index)}
                        >
                          <div
                            className="thumbnail"
                            style={{
                              width: "100%",
                              position: "relative",
                              overflow: "hidden",
                              borderRadius: "12px",
                              aspectRatio: "1 / 1",
                            }}
                          >
                            <img
                              src={img}
                              alt={`photo-${index}`}
                              loading="lazy"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "12px",
                                transition: "opacity 0.3s ease",
                                opacity: 1,
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    ))}
              </Slider>
            </div>
          </div>
        </div>

        {/* BLOG CONTENT */}
        <div className="rn-blog-details pb--70 bg_color--1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="inner-wrapper">
                  {blog.content.map((item, i) => {
                    switch (item.type) {
                      case "paragraph":
                        return <p key={i}>{item.text}</p>;

                      case "image":
                        return (
                          <div className="thumbnail mb--30" key={i}>
                            <img src={item.src} alt={item.alt} loading="lazy" />
                          </div>
                        );

                      case "blockquote":
                        return (
                          <blockquote className="rn-blog-quote" key={i}>
                            {item.text}
                          </blockquote>
                        );

                      case "list":
                        return (
                          <ul key={i}>
                            {item.items.map((li, idx) => (
                              <li key={idx}>{li}</li>
                            ))}
                          </ul>
                        );

                      default:
                        return null;
                    }
                  })}

                  {/* 🎥 Start Video Area (Dynamic) */}
                  {blog.videoPic && (
                    <div className="rn-section ptb--30 bg_color--1 line-separator">
                      <div className="container">
                        <div className="row sercice-details-content align-items-center">
                          <div className="col-lg-12">
                            <div className="thumb position-relative">
                              <img
                                className="w-100"
                                src={blog.videoPic}
                                alt={blog.title}
                              />

                              <ModalVideo
                                channel="youtube"
                                isOpen={this.state.isOpen}
                                videoId={blog.videoId}
                                onClose={() => this.setState({ isOpen: false })}
                              />

                              <button
                                className="video-popup position-top-center"
                                onClick={this.openModal}
                              >
                                <span className="play-icon"></span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* 🎥 End Video Area */}

                  {blog.videoText && <p>{blog.videoText}</p>}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* LIGHTBOX */}
        {isLightboxOpen && gallery.length > 0 && (
          <Lightbox
            mainSrc={gallery[photoIndex]}
            nextSrc={gallery[(photoIndex + 1) % gallery.length]}
            prevSrc={
              gallery[(photoIndex + gallery.length - 1) % gallery.length]
            }
            onCloseRequest={() => this.setState({ isLightboxOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + gallery.length - 1) % gallery.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % gallery.length,
              })
            }
            imageTitle={blog.title}
          />
        )}

        {/* BACK TO TOP */}
        <div className="backto-top">
          <ScrollToTop showUnder={160}>
            <FiChevronUp />
          </ScrollToTop>
        </div>

        <Footer />
      </>
    );
  }
}

function BlogDetailsWrapper(props) {
  const { slug } = useParams();
  const location = useLocation();
  const blogFromState = location.state?.blog;

  const blog =
    blogFromState || HouseDetailPageInfo.find((b) => b.slug === slug);

  return <BlogDetailsContent blog={blog} {...props} />;
}

export default BlogDetailsWrapper;
